import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import { useLocation } from 'react-router-dom';
import ProductoPublicModel from '../models/ProductoPublicModel';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // ✅ CATEGORÍAS ACTUALIZADAS
  const categories = [
    'Todos',
    'Café',
    'Confitería de Café',
    'Licores',
    'Otros Productos'
  ];

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoria = params.get('categoria');
    if (categoria) {
      const categoriaMap = {
        'cafe': 'Café',
        'confiteria': 'Confitería de Café',
        'licores': 'Licores',
        'otros': 'Otros Productos'
      };
      setSelectedCategory(categoriaMap[categoria] || 'Todos');
    }
  }, [location]);

  useEffect(() => {
    loadProducts();
  }, []);

  useEffect(() => {
    filterProducts();
  }, [selectedCategory, products]);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const data = await ProductoPublicModel.getAll();
      
      if (data && data.length > 0) {
        setProducts(data);
        setFilteredProducts(data);
      } else {
        setProducts([]);
        setFilteredProducts([]);
      }
    } catch (error) {
      console.error('Error cargando productos:', error);
      setProducts([]);
      setFilteredProducts([]);
    } finally {
      setLoading(false);
    }
  };

  const filterProducts = () => {
    let filtered = [...products];

    if (selectedCategory !== 'Todos') {
      filtered = filtered.filter(p => p.categoria === selectedCategory);
    }

    setFilteredProducts(filtered);
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Cargando productos...</p>
      </div>
    );
  }

  return (
    <div className="products-page">
      <div className="products-header">
        <h1>Nuestros Productos</h1>
        <p>Café · Confitería de Café · Licores · Otros Productos</p>
      </div>

      <div className="category-filter-container">
        <div className="category-filter">
          {categories.map(category => (
            <button
              key={category}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      <div className="products-count">
        Mostrando {filteredProducts.length} de {products.length} productos
      </div>

      {filteredProducts.length === 0 ? (
        <div className="no-products">
          <span className="no-products-icon">😕</span>
          <h3>No se encontraron productos</h3>
          <p>Intenta con otra categoría</p>
          <button 
            className="btn-primary"
            onClick={() => setSelectedCategory('Todos')}
          >
            Ver todos los productos
          </button>
        </div>
      ) : (
        <div className="products-grid">
          {filteredProducts.map(product => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Products;